/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Atlassian Intelligence에서 제공',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Atlassian Intelligence 기반',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    '콘텐츠는 사용자의 권한을 기반으로 하며 품질은 다를 수 있습니다',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': '콘텐츠 품질은 다를 수 있습니다',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': 'AI를 사용하고 결과를 확인하세요.',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': '정보',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': '현재 페이지에서 얻은 참조 자료 포함',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Atlassian Intelligence 로고',
  'fabric.editor.ai.components.backIconButton.backLabel': '뒤로',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': '취소',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': '취소',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': '취소',
  'fabric.editor.ai.components.feedbackForm.badResponse': '불량 응답',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': '피드백 보냄',
  'fabric.editor.ai.components.feedbackForm.goodResponse': '좋은 응답',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': '마지막 응답에서 계속',
  'fabric.editor.ai.config.item.action.copyResponse': '복사',
  'fabric.editor.ai.config.item.action.responseCopied': '복사됨!',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': '클립보드에 복사됨',
  'fabric.editor.ai.config.item.action.retryPrompt': '다시 시도',
  'fabric.editor.ai.experience-application.documentInsertError':
    '응답을 삽입하는 동안 문제가 발생했습니다. 대화 상자를 닫고 다시 시도하세요.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    '응답을 받을 수 없습니다. 프롬프트 또는 응답이 이 요청의 제한을 초과했습니다. 대화 상자를 닫고 다시 시도하세요.',
  'fabric.editor.ai.experience.apiError': '응답을 받을 수 없습니다. 다시 시도하세요.',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.inputTooShortError':
    '내용이 너무 짧아 요약할 수 없습니다. 내용을 더 추가하고 다시 시도하세요.',
  'fabric.editor.ai.experience.loadingAriaTitle': '생성 중',
  'fabric.editor.ai.experience.previewScreenLabel': '미리 보기',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    '에이전트에게 무엇이든 작성하도록 요청하거나 아래에서 선택하세요',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Rovo 로고',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': '뒤로',
  'fabric.editor.ai.screens.discard.discardLabel': '버리기',
  'fabric.editor.ai.screens.error.warningIconLabel': '경고',
  'fabric.editor.ai.screens.error.ariaErrorTitle': '오류',
  'fabric.editor.ai.screens.error.cancelLabel': '취소',
  'fabric.editor.ai.screens.error.retryLabel': '다시 시도',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': '라이브 업데이트 콘텐츠:',
  'fabric.editor.ai.screens.loading.iconAltText': '생성 아이콘',
  'fabric.editor.ai.screens.preview.betaLabel': '베타',
  'fabric.editor.ai.screens.preview.cancelLabel': '취소',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'AI에 다음에 해야 할 일을 알려주세요',
  'fabric.editor.ai.screens.preview.discardLabel': '버리기',
  'fabric.editor.ai.screens.preview.disclaimer': '정보 품질은 다를 수 있습니다.',
  'fabric.editor.ai.screens.preview.disclaimerLink': '이유 알아보기',
  'fabric.editor.ai.screens.preview.header.clear.hover': '지우기',
  'fabric.editor.ai.screens.preview.header.edit': '프롬프트 편집',
  'fabric.editor.ai.screens.preview.header.edit.hover': '편집',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': '다음으로 해야 하는 작업을 {agentName}에게 물어보세요',
  'fabric.editor.ai.screens.preview.refineButton': '상세 조정',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': '상세 조정',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Atlassian Intelligence 로고',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.submitLabel': '제출',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'AI에 보내기',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} - 선택',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': '제거',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': '제안',
  'fabric.editor.ai.shared.aiUniversalDescriptor': '글쓰기 어시스턴트',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Atlassian Intelligence에게 글쓰기 도움을 받으세요',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': '글쓰기',
  'fabric.editor.ai.shared.betaLabel': '베타',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI(Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': '베타',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': '신규',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'AI에게 말하세요:',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': '에이전트에게 말하기',
};
